import { createDom, addClass, removeClass, hasClass, toggleClass } from 'xgplayer/src/utils/util';
import '../style/controls/skip.scss';
let s_skip = function() {
  let player = this;
  let container = createDom('xg-skip', "<p class='name'>跳过</p>", {}, 'xgplayer-skip');

  ['touchend', 'click'].forEach((item) => {
    container.addEventListener(item, (e) => {
      e.stopPropagation();
      e.preventDefault();
      player.emit('video_skip');
    });
  });

  player.once('ready', () => {
    player.controls.appendChild(container);
  });
};

export default {
  name: 's_skip',
  method: s_skip
};
